'use client';

import dynamic from 'next/dynamic';
import Head from 'next/head';
import styled from 'styled-components';

import { Box, Breakpoints, Flex, Spacing } from '@zoomit/primitives';
import { theme } from '@zoomit/zoomit-ds';

import { ErrorPages } from '../../constants/errorPages';
import { Menu } from './menu/Menu';

type Props = {
  error?: '404' | '500' | 'general-error';
};

const Error500 = dynamic(() => import('./ErrorImages/500'));
const Error404 = dynamic(() => import('./ErrorImages/500'));
const ErrorGeneral = dynamic(() => import('./ErrorImages/500'));

const ErrorComponents = (props: Props) => {
  const { error = 'general-error' } = props;

  const errorData = ErrorPages().get(error);

  if (errorData === undefined) return null;

  const { errorCodeTitle, errorDescription, errorTitle, errorHeadTitle } = errorData;
  return (
    <>
      <Box>
        {error === 'general-error' ? (
          <Head>
            <title>app client error</title>
            <meta
              name="description"
              content={`زوبین مرجع اخبار فناوری، آموزش، راهنمای خرید و بررسی  تخصصی محصولات الکترونیک، ویدیو و مشخصات فنی و مقایسه موبایل، لپ تاپ، کامپیوتر و خودرو`}
            />
          </Head>
        ) : (
          <Head>
            <title>{errorHeadTitle}</title>
            <meta
              name="description"
              content={`زوبین مرجع اخبار فناوری، آموزش، راهنمای خرید و بررسی  تخصصی محصولات الکترونیک، ویدیو و مشخصات فنی و مقایسه موبایل، لپ تاپ، کامپیوتر و خودرو`}
            />
          </Head>
        )}
        <Menu />
        <Wrapper justifyContent="center" alignItems="center">
          <Flex flexDirection="column" alignItems="center" gap={Spacing.x2}>
            <Flex justifyContent="center">
              <ImageWrapper>
                {error === '500' && <Error500 />}
                {error === '404' && <Error404 />}
                {error === 'general-error' && <ErrorGeneral />}
              </ImageWrapper>
            </Flex>
            <ErrorHeaderWrapper justifyContent="center" alignItems="center" gap={Spacing.x}>
              <ErrorCode> {errorCodeTitle}</ErrorCode>
              <ErrorHeaderText>
                <DesktopView> - </DesktopView>
                {errorTitle}
              </ErrorHeaderText>
            </ErrorHeaderWrapper>
            <Flex>
              <ErrorDescription>{errorDescription()}</ErrorDescription>
            </Flex>
          </Flex>
        </Wrapper>
      </Box>
    </>
  );
};

const Wrapper = styled(Flex)`
  width: 100%;
  overflow-x: hidden;
  padding: 3rem;

  .container {
    @media (max-width: ${Breakpoints.md}) {
      width: 35rem;
    }
  }
`;

const ErrorHeaderText = styled.h2`
  font-size: 2.2rem;
  font-weight: bold;
  color: var(${theme.text});
  margin: 0;

  @media (max-width: ${Breakpoints.md}) {
    line-height: 1.85;
  }
`;

const ErrorHeaderWrapper = styled(Flex)`
  @media (max-width: ${Breakpoints.md}) {
    flex-direction: column;
  }
`;

const ErrorDescription = styled.p`
  font-size: 1.6rem;
  color: var(${theme.text});
  margin: 0.8rem 0;
  text-align: center;
  line-height: 2;

  @media (max-width: ${Breakpoints.md}) {
    padding: 0 3rem;
  }
`;

const ErrorCode = styled.span`
  height: 40px;
  font-size: 2.2rem;
  font-weight: bold;
  color: var(${theme.textHover});
  display: flex;
  align-items: center;
`;

const ImageWrapper = styled(Flex)`
  position: relative;
  width: 40rem;
  height: auto;

  @media (max-width: ${Breakpoints.md}) {
    svg {
      height: 300px;
    }
    padding: 0 2rem;
    width: 38rem;
    height: auto;
  }
`;

const DesktopView = styled.span`
  @media (max-width: ${Breakpoints.md}) {
    display: none;
  }
`;
export default ErrorComponents;
